import { z } from 'zod/v4'

export class SearchError extends Error {
  public id: string
  public status: number
  public constructor(message: string, id: string, status: number) {
    super(message)
    this.id = id
    this.status = status
  }
}

export const ASK_QUOTA_EXCEEDED_ERROR = 'quota-exceeded'
export const ASK_RATE_LIMITED_ERROR = 'rate-limited'
export const ASK_NO_ANSWER_ERROR = 'no-answer'
export const ASK_DISABLED_ERROR = 'cant-use-ask'
export const SUPER_NO_SUBSCRIPTION_ERROR = 'no-subscription'

export const ASK_STREAM_ERROR = 'ask-stream-error'

export class AskQuotaExceededError extends SearchError {
  public limit?: number | null
  public resetDate?: string | null
  public constructor(
    message: string,
    data: { limit?: number | null; resetDate?: string | null }
  ) {
    super(message, ASK_QUOTA_EXCEEDED_ERROR, 429)
    this.limit = data.limit
    this.resetDate = data.resetDate
  }
}

export class AskDisabledError extends SearchError {
  public constructor(message: string) {
    super(message, ASK_DISABLED_ERROR, 422)
  }
}

export class SuperNoSubscriptionError extends SearchError {
  public constructor(message: string) {
    super(message, SUPER_NO_SUBSCRIPTION_ERROR, 403)
  }
}

export class AskRateLimitedError extends SearchError {
  public constructor(message: string) {
    super(message, ASK_RATE_LIMITED_ERROR, 429)
  }
}

export class AskNoAnswerError extends SearchError {
  public totalWords: number
  public constructor(message: string, totalWords: number) {
    super(message, ASK_NO_ANSWER_ERROR, 404)
    this.totalWords = totalWords
  }
}

// {"message":"404 The model `gpt-4-turbo` does not exist or you do not have access to it.","name":"Error"}
const AskStreamErrorSchema = z.object({
  message: z.string(),
})

function extractAskStreamErrorMessage(data: unknown): { message: string } {
  if (typeof data !== 'string') {
    return { message: JSON.stringify(data) }
  }

  let parsedJSON = null

  try {
    parsedJSON = JSON.parse(data)
  } catch (e) {
    return { message: data }
  }

  const parsedData = AskStreamErrorSchema.safeParse(parsedJSON)

  if (parsedData.success) {
    return { message: parsedData.data.message }
  }
  return { message: data }
}

export class AskStreamError extends SearchError {
  public constructor(data: unknown) {
    const { message } = extractAskStreamErrorMessage(data)
    super(message, ASK_STREAM_ERROR, 500)
  }
}
